module.exports = __webpack_public_path__ + "static/img/certificado-energetico-01.290de26c.jpeg";